import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_BOOKING_DROPDOWN, GET_BOOKING_DROPDOWN_SUCCESS, GET_BOOKING_DROPDOWN_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getBookingDropdown({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* query: { user_id, booking_type_id } */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/booking-dropdown`,
      method: 'GET',
      headers: { ...filteredHeaders },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_DROPDOWN_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_DROPDOWN_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_DROPDOWN_ERROR, payload: error });
  }
}

export function* watchGetBookingDropdown() {
  yield takeEvery(GET_BOOKING_DROPDOWN, getBookingDropdown);
}

function* getBookingDropdownSaga() {
  yield all([fork(watchGetBookingDropdown)]);
}

export default getBookingDropdownSaga;
